export default __webpack_public_path__ + "static/media/OurJourney-01.02ec996a.jpg";